export default "/images/vendor/flag-icon-css/flags/4x3/au.svg?6734a27a2f2a54332a4c8517deb08876";